const STORAGE_KEY = 'klCsConversationId'

function getBaseUrl() {
  return (process.env.VUE_APP_BASE_API2 || '').replace(/\/$/, '')
}

function authHeaders() {
  const headers = { 'Content-Type': 'application/json' }
  const accessToken = sessionStorage.getItem('accessToken')
  if (accessToken) {
    headers.accessToken = encodeURIComponent(accessToken)
  }
  return headers
}

export function getCsConversationId() {
  return localStorage.getItem(STORAGE_KEY) || ''
}

export function setCsConversationId(id) {
  if (id) localStorage.setItem(STORAGE_KEY, id)
}

export function clearCsConversationId() {
  localStorage.removeItem(STORAGE_KEY)
}

function consumeCsSseBuffer(buffer, handlers = {}) {
  const sep = /\r?\n\r?\n/
  let rest = buffer
  let m
  while ((m = rest.match(sep))) {
    const block = rest.slice(0, m.index)
    rest = rest.slice(m.index + m[0].length)
    for (const line of block.split(/\r?\n/)) {
      if (!line.startsWith('data:')) continue
      const raw = line.slice(5).trim()
      if (!raw || raw === '[DONE]') continue
      try {
        const j = JSON.parse(raw)
        if (j.conversationId && handlers.onConversationId) handlers.onConversationId(j.conversationId)
        if (j.status === 'tool' && handlers.onTool) handlers.onTool(j.name)
        if (j.t && handlers.onDelta) handlers.onDelta(j.t)
        if (j.done && handlers.onDone) handlers.onDone()
        if (j.error && handlers.onError) handlers.onError(j.error)
      } catch {
        /* ignore */
      }
    }
  }
  return rest
}

export async function syncChat({ message, conversationId }) {
  const res = await fetch(getBaseUrl() + '/klgeek/cs/agent', {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ message, conversationId: conversationId || undefined }),
  })
  const json = await res.json()
  if (json.code !== 200) {
    throw new Error(json.msg || '请求失败')
  }
  return json.data
}

export async function streamChat({ message, conversationId }, handlers = {}) {
  const res = await fetch(getBaseUrl() + '/klgeek/cs/agent/stream', {
    method: 'POST',
    headers: { ...authHeaders(), Accept: 'text/event-stream' },
    body: JSON.stringify({ message, conversationId: conversationId || undefined }),
  })
  if (!res.ok || !res.body) {
    throw new Error('流式请求失败')
  }
  const reader = res.body.getReader()
  const decoder = new TextDecoder()
  let buf = ''
  let streamDone = false
  while (!streamDone) {
    const { done, value } = await reader.read()
    streamDone = done
    if (value) {
      buf += decoder.decode(value, { stream: true })
      buf = consumeCsSseBuffer(buf, handlers)
    }
  }
  buf += decoder.decode()
  consumeCsSseBuffer(buf, handlers)
}

export async function clearMemory(conversationId) {
  if (!conversationId) return
  await fetch(getBaseUrl() + '/klgeek/cs/agent/memory/' + encodeURIComponent(conversationId), {
    method: 'DELETE',
    headers: authHeaders(),
  })
}
